/* eslint-disable no-empty-pattern */
import React, { createContext, useCallback, useContext } from 'react';
import PropTypes from 'prop-types';
import { useConfirmationModal } from 'LocalGluons/components/ConfirmationModal';
import { SystemInfoHelper } from '../../../AppManager/helpers/SystemInfoHelper';

export const AppErrorHandlerProvider = ({ children, logFunction }) => {
    const { setErrorModal } = useConfirmationModal();

    const setErrorCallback = useCallback(
        async ({ error, screenId, context = 'userAction', closeErrorModalCallback }) => {
            console.log(screenId, context, error);
            setErrorModal(error, closeErrorModalCallback);
            const systemInfo = new SystemInfoHelper();
            await systemInfo.load();
            logFunction({
                time: Date.now(),
                type: 'error',
                subtype: screenId,
                error: error.errorCode || error.message,
                context,
                ...systemInfo.get()
            });
        },
        []
    );

    return (
        <AppErrorHandlerContext.Provider
            value={{
                setError: setErrorCallback
            }}
        >
            {children}
        </AppErrorHandlerContext.Provider>
    );
};

AppErrorHandlerProvider.defaultProps = {
    children: [],
    logFunction: () => {}
};

AppErrorHandlerProvider.propTypes = {
    children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
    logFunction: PropTypes.func
};

export const AppErrorHandlerContext = createContext({
    setError: ({}) => {}
});

export const useAppErrorHandler = () => useContext(AppErrorHandlerContext);

export const withAppErrorHandler = (Component) => (props) =>
    (
        <AppErrorHandlerContext.Consumer>
            {(context) => <Component {...props} {...context} />}
        </AppErrorHandlerContext.Consumer>
    );
